import moment from 'moment'
import {franc} from 'franc';
import Cookies from 'js-cookie';

const globalMixin = {

  use: { moment, franc},
  data(){
    return {
    }
  },
  computed: {
    site_url(){
      return window.site_url;
    },
  
    color_array(){
      return [
        'rgba(236, 34, 108, 1)',
        'rgba(50, 107, 213, 1)',
        'rgba(95, 212, 165, 1)',
        'rgba(75, 192, 192, 0.2)',
        'rgba(153, 102, 255, 0.2)',
        'rgba(255, 159, 64, 0.2)',
        'rgba(255, 99, 132, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(255, 206, 86, 0.2)',
        'rgba(75, 192, 192, 0.2)',
        'rgba(153, 102, 255, 0.2)',
        'rgba(255, 159, 64, 0.2)'
      ];
    },
    
    border_array(){
      return [
        'rgba(236, 34, 108, 1)',
        'rgba(50, 107, 213, 1)',
        'rgba(95, 212, 165, 1)',
        'rgba(255,255,255,1)',
        'rgba(255,255,255,1)',
        'rgba(255,255,255,1)',
        'rgba(255,255,255,1)',
        'rgba(255,255,255,1)',
        'rgba(255,255,255,1)',
        'rgba(255,255,255,1)',
      ];
    },
    isApp(){ 
      //return true;
      return (!this.isNull(window.cordova) && window.cordova != false); // true
    },
    isIOS(){
      return (this.isApp && this.getMobileOperatingSystem() == 'iOS');
      //return false;
    },
    ageComp(){
      let user = this.get_me();
      
      let ret;

      let age = user.age;
      if (age < 20) age = 20;

      if (age >= 40)
      {
        if (user.gender == 'male') ret = {min: (age - 15), max: (age + 7) };
        else return ret = {min: (age - 7), max: (age + 15) };
      }
      else
      {
        if (user.gender == 'male') ret = {min: (age - 10), max: (age + 3) };
        else return ret = {min: (age - 3), max: (age + 10) };
      }

      if (ret.min < 20) ret.min = 20;
      if (ret.max <= ret.min) ret.max = ret.min + 10;

      return ret;
    },

  },

  methods: {
    isHeb(lyrics){
      try {
        const languageCode = franc(lyrics);
        
        return languageCode === 'heb';
      } catch (error) {
        // In case of any error, return false
        return false;
      }
    },
    formatDate(value) {
      if (value) 
      {
        return moment(String(value)).format('DD.MM.YY')
      }
    },

    userToken(){
      if(!this.isNull(localStorage.getItem('user_token'))) {
        return true;
      }

      return false;
    },

    bg(pic){
      return 'background-image:url(' + pic + ')';
    },
    
    validate_id(id){
      if (id == false || this.isNull(id)) return false;
      else return true;
    },

    logout(){
      localStorage.removeItem('user_token');
      Cookies.remove('CRM_login_users');
      var myDate = new Date();
      myDate.setMonth(myDate.getMonth() + 12);
      let cookieName = 'app_user';
      let cookieValue = '0';
      document.cookie = cookieName +"=" + cookieValue + ";expires=" + myDate + ";domain=.7brachot.co.il;path=/";

      this.$bus.$emit('reload');
      //document.location = '/';
    },

    goto(url) {
      if (!url) return;
      if (typeof url === 'string' && /^https?:\/\//.test(url)) {
        document.location = url;
        return;
      }
      this.$router.push(url);
    },
    
    get_me(){
      return this.$store.user;
    },
    getMyGender(){
      return this.get_me().gender;
    },
    getOtherGender(){
      return this.getMyGender() == 'male' ? 'female' : 'male';
    },
    get_word(key, gender){
      if (this.isNull(gender)) 
      {
        let me = this.get_me();
        if (me) gender = me.gender;
        else gender = 'male';
      }

      // check subs
      if (this.isNull(this.$store.words[key])) 
      {
        for (let i in this.$store.words)
        {
          if (!this.isNull(this.$store.words[i].sub) && !this.isNull(this.$store.words[i].sub[key]))
          { 
            if (gender == 'female') return this.$store.words[i].sub[key].value_female;
            else return this.$store.words[i].sub[key].value_male;
          }
        }
        return '';
      }
      if (gender == 'female') return this.$store.words[key].value_female;
      else return this.$store.words[key].value_male;
    },
    get_param(key, val, gender){ 

      //console.log(key, val, gender)
      //console.log(key);
      //console.log(this.$store.params[key].values);
      if (this.isNull(this.$store.params[key]) || this.isNull(this.$store.params[key].values[val])) return '';
      if (gender == 'female') return this.$store.params[key].values[val].name_female
      else return this.$store.params[key].values[val].name
    },
    get_param_values(key, gender){
      if (this.isNull(this.$store.params[key])) return [];

      let arr = [];
      for(let i in this.$store.params[key].values)
      {
        let item = this.$store.params[key].values[i];
        arr.push({id: item.id, value: item.value, name: (gender == 'female' ? item.name_female : item.name)});
      }

      return arr;
    },
    get_search_param_values(key, gender){
      if (this.isNull(this.$store.search_bar_params[key])) return [];

      let arr = [];
      for(let i in this.$store.search_bar_params[key].values)
      {
        let item = this.$store.search_bar_params[key].values[i];
        arr.push({id: item.id, value: item.value, name: (gender == 'female' ? item.name_female : item.name)});
      }

      return arr;
    },

    list_get_value(values, value){
      for (let i in values)
      {
        if (values[i].id == value) return values[i].text;
      }
      return '';
    },

    format_number: function(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    isNull: function (str)
    {
      return (str == '' || str == null || str == undefined);
    },
    alert(msg){
      //this.$alert(msg);

      this.$swal.fire({ html: msg, confirmButtonText: 'אוקי', showCloseButton: true});


      //this.$toasted.show(msg, { type: 'success', theme: "toasted-primary", position: "top-left", duration : 3000 } )
    },
    pushIfNotExist(element, comp) {
      if (element.indexOf(comp) == -1) {
        element.push(comp);
      }
    },
    pushOrPull(element, comp) {
      var index = element.indexOf(comp);
      if (index == -1) {
        element.push(comp);
      }
      else
      {
        element.splice(index, 1);
      }
      return element;
    },
    inArray(element, comp) {
      return (element.indexOf(comp) != -1);
    },

    parse_items(items){
      for (let i in items)
      {
       
        for (let i2 in items[i].songs)
        {
          items[i].songs[i2].playing_now = false;
        }
      }
    },
    success(msg) {
			this.$swal.fire({ html: msg, confirmButtonText: "אישור", icon: 'success' });
		},
    notLoggedAlert(msg = 'עליך להתחבר למערכת', showCancelButton = true, confirmButtonText = '<a href="/catalog">קח אותי להתחברות</a>', cancelButtonText = 'אישור') {
			this.$swal.fire({ html: msg, confirmButtonText, showCancelButton, cancelButtonText, icon: 'error' });
		},
    checkLogged(){
      if (!this.get_me()) {
        this.notLoggedAlert();
        return false;
      }
      return true;
    },
    checkIsMediaUser(){
      if (this.get_me() && this.get_me().type == 'media') return true;
      else {
        this.notLoggedAlert('הורדת קבצי מדיה מלינקטון אפשרית לאנשי מדיה בלבד', false, 'אישור');
        return false;
      }
    },
    set_user_token(str)
    {
      localStorage.setItem('user_token',str);
  
      var myDate = new Date();
      myDate.setMonth(myDate.getMonth() + 12);
      let cookieName = 'app_user';
      let cookieValue = (str == '' ? '0' : '1');
      document.cookie = cookieName +"=" + cookieValue + ";expires=" + myDate + ";domain=.linktone.co.il;path=/";
    },





    api(settings, func, failFunc){
    
      if (this.isNull(func)) func = function(){};
  
       var headers = {};
       if (!(settings.data instanceof FormData)) {
         headers['Content-Type'] = 'application/json; charset=utf-8';
       }
      
       if(!this.isNull(localStorage.getItem('user_token'))) 
       { 
         headers.Authorization = localStorage.getItem('user_token');
       }
     
//         var requestOBJ;
       const cancelTokenSource = this.axios.CancelToken.source();

  
         if (settings.method == 'get')
         {
            let actionGet = settings.action;
            actionGet = actionGet + (actionGet.indexOf('?') === -1 ? '?' : '&');
            actionGet = actionGet + 'ts='  + (new Date()).getHours() + '_' + ((new Date()).getMinutes() < 30 ? '0' : '30');

            if (!this.isNull(settings.data))
            { 
            for (let i in settings.data) actionGet += '&' + i + '=' + settings.data[i];
            }

             this.axios.get(window.api_url + actionGet, { headers: headers, cancelToken: cancelTokenSource.token } ).then(response => {
              if (response.data == 'error')
              {
                this.set_user_token('');
                document.location.reload();
              }

              func(response.data);
           }, response => { 
             if (!this.isNull(failFunc)) failFunc(response);
             //else func(false);
           });
      

// Cancel request
//cancelTokenSource.cancel();

         }
         else
         {
          this.axios.post(window.api_url + settings.action, settings.data, { headers: headers, cancelToken: cancelTokenSource.token })
          .then(response => {
            if (response.data == 'error')
            {
              this.set_user_token('');
              this.$bus.$emit('reload');
            }
               func(response.data);
               //console.log(response.body);
           }, response => { 
             if (!this.isNull(failFunc)) failFunc(response);
             //else func(false);
               //console.error(response.body);
           });
       }
       
      return cancelTokenSource;
  
     },

    is_mobile(){ 
      
      const userAgent = navigator.userAgent.toLowerCase();
      const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);
      if (isTablet) return false;
      

      const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
    ];

    return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
    });
    
    },
    
    hideUser(item){
      if (item.is_rel_hide)
      {
        item.is_rel_hide = false;
        this.api({ action: 'user_hide/remove', data: {hide_user_id: item.id}}, () => {
          this.alert('ההסתרה הוסרה');
        });
      }
      else
      {
        item.is_rel_hide = true;

        this.api({ action: 'user_hide/add', data: {hide_user_id: item.id}}, () => {
          this.alert('המשתמש מוסתר');
          item.hide = true;
          this.$emit('close');
        });
      }

    },

    
    blockUser(item){
      if (item.is_rel_blocked)
      {
        item.is_rel_blocked = false;
        this.api({ action: 'user_blocks/remove', data: {blocked_user_id: item.id}}, () => {
          this.alert('החסימה הוסרה');
        });
      }
      else
      {
        this.$bus.$emit('block-panel', item);

        //this.blockUser_do(item);
      }

    },

    blockUser_do(item, data){
      
      item.is_rel_blocked = true;

      data.blocked_user_id = item.id;

      this.api({ action: 'user_blocks/add', data: data }, () => {
        this.alert('המשתמש נחסם');
        item.hide = true;
        this.$emit('close');
      });
    },

    report(item){

      this.$bus.$emit('report-panel', item);
    },
    
    allowPerms(item){
      this.api({ action: 'user/allow_perms', data: {to_user_id: item.id} }, () => { 
        this.alert(item.first_name + ' ' + this.get_word('user_can_see', item.gender));
        item.photos_perms_to_me = '1';
      });
    },
    
    disallowPerms(item){
      this.api({ action: 'user/disallow_perms', data: {to_user_id: item.id} }, () => { 
        this.alert(item.first_name + ' ' + this.get_word('user_cannot_see', item.gender));
        item.photos_perms_to_me = '0';
      });
    },

    user_status_line(item){
      let arr = [];
      let ret = '';
      arr[0] = this.get_param('martial_statuses', item.martial_status_id, item.gender);
      arr[1] = this.get_param('cities', item.city_id, item.gender);
      arr[2] = this.get_param('religious_views', item.religious_view_id, item.gender);
      
      for (let i in arr)
      {
        if (arr[i] != '') ret += '<span>' + arr[i] + '</span>';
      }

      return '<div class="user_status_line">' + ret + '</div>';
    },

    user_status_line2(item){
      let arr = [];
      let ret = '';
      arr[0] = this.get_param('martial_statuses', item.martial_status_id, item.gender);
      arr[1] = item.age;
      arr[2] = this.get_param('cities', item.city_id, item.gender);
      
      for (let i in arr)
      {
        if (arr[i] != '') ret += '<span>' + arr[i] + '</span>';
      }

      return '<div class="user_status_line">' + ret + '</div>';
    },

    user_status_line_inbox(item){
      if (this.isNull(item)) return 'משתמש לא פעיל';
      let arr = [];
      let ret = '';
      arr[0] = (!this.isNull(item.first_name) ? item.first_name : 'משתמש לא פעיל');
      arr[1] = this.get_param('martial_statuses', item.martial_status_id, item.gender);
      arr[2] = (this.isNull(item.age) ? '' : item.age);
      //arr[3] = this.get_param('martial_statuses', item.martial_status_id, item.gender);
      //arr[4] = this.get_param('cities', item.city_id, item.gender);
      
      for (let i in arr)
      {
        if (arr[i] != '') ret += '<span>' + arr[i] + '</span>';
      }

      return '<div class="user_status_line">' + ret + '</div>';
    },

    update_location()
    {
      
      navigator.geolocation.getCurrentPosition((location) => {

        this.api({ action: 'user/update_location', data: {lat: location.coords.latitude, lon: location.coords.longitude}}, () => {
          //this.alert('ההסתרה הוסרה');
        });
/*
        console.log(location.coords.latitude);
        console.log(location.coords.longitude);
        console.log(location.coords.accuracy);
*/

      });
      
    },

    getMobileOperatingSystem()
    {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
      // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
          return "Windows Phone";
      }
  
      if (/android/i.test(userAgent)) {
          return "Android";
      }

      // iOS detection from: http://stackoverflow.com/a/9039885/177710
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          return "iOS";
      }
  
      return "unknown";
  }
  



   }

}

export default globalMixin